import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'
import Processor from '../Processor'

export default function MachineInput({
  type,
  formState,
  tags,
  options,
  inputLabel,
  referenceConfig,
  onChange,
  name,
  separator = '-',
  ...props
}) {
  let classes = ['form-input', 'form-input--machine']

  return (
    <Form.Input
      {...props}
      name={name}
      type="text"
      className={classes.join(' ')}
      onChange={e => onChange({ name, value: Processor(e.target.value, separator === '_' ? ['machine'] : ['slug']) })}
    />
  )
}
